import React from "react";

export default function ResultRanking({ allRank }) {
  const maxItems = 20; // Maximum number of items to display
  const itemsToDisplay = allRank.slice(0, maxItems); // Get top 20 items

  return (
    <div className="my-8">
      <h3 className="text-lg font-bold">Top 20 Result</h3>
      <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
        <thead>
          <tr className="border-b border-slate-600/50">
            <th className="table-th !text-center">Rank</th>
            <th className="table-th !text-center">Name</th>
            <th className="table-th !text-center">Quiz Mark</th>
            <th className="table-th !text-center">Assignment Mark</th>
            <th className="table-th !text-center">Total</th>
          </tr>
        </thead>

        <tbody>
          {itemsToDisplay?.map((user) => {
            return (
              <tr
                className="border-b border-slate-600/50"
                key={user.student_id}
              >
                <td className="table-td text-center">{user.rank}</td>
                <td className="table-td text-center">{user.student_name}</td>
                <td className="table-td text-center">{user.quizTotal}</td>
                <td className="table-td text-center">{user.assignmentTotal}</td>
                <td className="table-td text-center">{user.total}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
